module.exports = __webpack_public_path__ + "f757585a28dc085be4fdb8209b393be2.svg";